import { cn } from "../../lib/utils";

export function History({ className, ...props }: React.ComponentProps<"div">) {
  return <div {...props} className={cn("", className)} />;
}

export function HistoryBorder() {
  return <div className="w-1 bg-secondary top-8 bottom-0 absolute left-3.5" />;
}

export function HistoryEvent({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      {...props}
      className={cn("flex gap-4 relative items-start pb-4", className)}
    />
  );
}

export function HistoryEventDate({
  className,
  ...props
}: React.ComponentProps<"span">) {
  return (
    <span
      {...props}
      className={cn(
        "italic text-muted-foreground text-xs font-semibold",
        className,
      )}
    />
  );
}

export function HistoryEventTitle({
  className,
  ...props
}: React.ComponentProps<"span">) {
  return (
    <span
      {...props}
      className={cn("inline-flex items-center gap-1 [&_svg]:size-4", className)}
    />
  );
}

export function HistoryEventTextualContent({
  className,
  ...props
}: React.ComponentProps<"p">) {
  return (
    <p
      {...props}
      className={cn("text-xs text-muted-foreground max-w-full", className)}
    />
  );
}

export function HistoryEventContent({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      {...props}
      className={cn(
        "flex flex-col gap-1 text-sm font-medium mt-1.5",
        className,
      )}
    />
  );
}

export function HistoryEventIcon({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      {...props}
      className={cn(
        "rounded-full flex items-center border justify-center size-8 bg-secondary",
        className,
      )}
    />
  );
}
